export enum PageState {
  LOADING = "LOADING",
  SUCCESS = "SUCCESS",
  ERROR = "ERROR",
}

export function isLoadingState(state: PageState) {
  return state === PageState.LOADING;
}

export function isSuccessState(state: PageState) {
  return state === PageState.SUCCESS;
}

export function isErrorState(state: PageState) {
  return state === PageState.ERROR;
}
